<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="alumno/reporte" titulo="Reporte / Alumno" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div id="banner" align="center" *ngIf="ctrl.cargando || ctrl.cargarDatosCatalogo || cargando">
  <div class="bloquear-azul">

  </div>
  <span class="tag is-primary is-large " style="position: absolute; top: 45%; font-size: 2em; z-index: 999999999;  left: 45%;">
    <span class="icon">
      <i class="icon-worldwide fa-spin"></i>
    </span> &nbsp;
    <span>Cargando...</span>
  </span>
</div>

<div class="contenedor columns " style="height:100%; ">
  <div class="column is-2 is-hidden-mobile menu-izquierda">

    <!-- Menu izquierda del modulo enviroment" -->
    <app-sistema-menu-aside></app-sistema-menu-aside>
  </div>
  <div class="column" style="padding:0px;">
    <div style="background: #FFF; border-radius: 1em; height:100%;">

      <!-- formulario -->
      <section class="hero is-primary">
        <div class="hero-body">
          <a id="catalogos" (click)="ctrl.cargarCatalogo('logos64', 'logos64', 'logo64');"></a>
          <a id="logo64" (click)="asignarLogos(ctrl.logos64); "></a>
          <a id="message" (click)="ctrl.mostrar_mensaje(titulo, mensaje, clase);"></a>
          <!-- Opciones  -->
          <section class="hero is-primary">
            <div class="hero-head">
              <nav class="level">
                <!-- Left side -->
                <div class="level-left">
                  <div class="level-item">
                    <p class="title">
                      <span *ngIf="!ctrl.cargando" class="icon is-medium">
                        <i class="icon-candidates-1"></i>
                      </span>
                      <span *ngIf="ctrl.cargando  || cargando" class="icon is-medium">
                        <i class="icon-election fa-spin"></i>
                      </span>
                      <span class="icon is-medium">
                        <i class="icon-file"></i>
                      </span> Reporte por alumno
                    </p>
                  </div>

                </div>

                <!-- Right side -->
                <div class="level-right">

                  <a class="navbar-item is-primary tooltip" (click)="ctrl.regresar()">
                    <span class="icon fa-2x">
                      <i class="icon-back"> </i>
                    </span>
                    <span class="tooltiptext">Regresar</span>
                  </a>

                  <a class="navbar-item is-primary tooltip" (click)="cargarDatos(alumnos.id)" id='cargar_datos_actualizar'
                    *ngIf="alumnos.id != ''">
                    <span class="icon fa-2x">
                      <i class="icon-worldwide"></i>
                    </span>
                    <span class="tooltiptext">Actualizar</span>
                  </a>

                  <button class="navbar-item  tooltip" type="button" (click)="imprimirKardex(dato)" *ngIf="alumnos.id != ''">
                    <span class="icon fa-2x has-text-black">
                      <i class="icon-printer"></i>
                    </span>
                    <span class="tooltiptext">Imprimir Kardex</span>
                  </button>


                </div>
              </nav>
            </div>
          </section>
        </div>
      </section>

      <section class="section" style="overflow-y:auto; overflow-x:hidden; padding: 1rem; height: 86vh;">
        <section class="hero is-primary">
          <div class="hero-body">
            <nav class="level ">
              <!-- Left side -->
              <div class="level-left ">
                <div class="level-item">
                  <p class="title">
                    <span *ngIf="!ctrl.cargando || !cargando" class="icon is-medium">
                      <i class="icon-edit-1"></i>
                    </span>
                    Buscar alumnos
                  </p>
                </div>
              </div>
              <div class="level-right " style=" width: 78%; ">
                <div class="level-item" style=" width: 100%; ">
                  <div class="control has-icons-left is-expanded" style=" width: 100%; ">
                    <input autofocus autocomplete="off" ngui-auto-complete [source]="observableSource.bind(this)"
                      [list-formatter]="autocompleListFormatter" [close-on-focusout]="false" id='buscarArticulo' value-property-name="id"
                      display-property-name="id" path-to-data="" loading-text="Cargando..."
                      no-match-found-text="No hay resultados." (valueChanged)="select_articulo_autocomplete($event)"
                      min-chars="3" class="input is-success is-medium" type="text"
                      placeholder="Escribe el nombre del alumno, o la matrícula">
                    <span class="icon is-medium is-left">
                      <i class="icon-search3"></i>
                    </span>
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </section>
        <div class="is-fullwidth has-text-centered" *ngIf="cargando">
          <br>
          <span class="tag is-primary is-large ">
            <span class="icon">
              <i class="icon-worldwide fa-spin"></i>
            </span> &nbsp;
            <span>Cargando...</span>
          </span>
        </div>

        <section style="overflow:auto;">


          <div class="tile" *ngIf="alumnos.alumnos_metadatos.nombre != ''">
            <div class="tile is-parent">
              <article class=" tile is-child notification">

                <div class="content" >
                  <div class="box">
                    <article class="media">
                      <div class="media-left">
                        <figure class="image is-64x64">
                          <img
                            [src]="alumnos.alumnos_metadatos.foto != null ? ctrl.API_PATH+'/adjunto/alumnos/'+alumnos.alumnos_metadatos.foto : './assets/128x128.png'"
                            alt="Image">
                        </figure>
                      </div>
                      <div class="media-content">
                        <div class="content">
                          <p>
                            <strong>
                              {{alumnos.alumnos_metadatos.nombre }} {{alumnos.alumnos_metadatos.apellido_paterno }}
                              {{alumnos.alumnos_metadatos.apellido_materno }}
                            </strong>
                            <small>{{alumnos.alumnos_metadatos.email}}</small>
                            <span> Grupo: {{alumnos.grupos.clave}}</span>
                            <span> Nivel: {{alumnos.grupos.nivel}} {{alumnos.grupos.identificador}}</span>
                            <span> Beca: {{alumnos.becas ? alumnos.becas.becas.nombre : 'Sin beca'}}</span>
                            <br>
                            <strong> Carrera Plan:</strong> {{alumnos.carrera_plan.nombre}}
                            <strong> Carrera:</strong> {{alumnos.carreras.nombre}}
                            <br>
                            <strong> Modalidad:</strong> {{alumnos.modalidades.nombre}}
                          </p>

                        </div>
                      </div>
                    </article>
                  </div>

                  <div class="columns" style="margin-top: 20px;"
                    *ngIf="permisos.indexOf('AlumnoOperacionController.reporte') > -1 && (kardex.length > 0 || finanza.data.length > 0 || lista_incidencias.length > 0)">
                    <div class="column is-4" style="padding: 0px;" *ngIf="kardex.length > 0">
                      <button class="button is-fullwidth is-fullheight" type="button"
                        (click)="ctrl.abrirModal('reporte'); imprimirKardex();" style="height: 100px;">
                        <span class="icon is-small is-right">
                          <i class="icon-exam"></i>
                        </span>
                        <span>Historial acádemico</span>
                      </button>
                    </div>

                    <div class="column is-4" style="padding: 0px;" *ngIf="finanza.data.length > 0">
                      <button class="button is-fullwidth is-fullheight" type="button"
                        (click)="ctrl.abrirModal('reporte'); imprimirFinanza();" style="height: 100px;">
                        <span class="icon is-small is-right">
                          <i class="icon-money4"></i>
                        </span>
                        <span>Historial financiero</span>
                      </button>
                    </div>

                    <div class="column is-4" style="padding: 0px;" *ngIf="lista_incidencias.length > 0">
                      <button class="button is-fullwidth is-fullheight" type="button"
                        (click)="ctrl.abrirModal('reporte'); imprimirIncidencia();" style="height: 100px;">
                        <span class="icon is-small is-right">
                          <i class="icon-insurance"></i>
                        </span>
                        <span>Historial de incidencias</span>
                      </button>
                    </div>

                  </div>
                </div>
              </article>
            </div>
          </div>

        </section>
      </section>
    </div>
  </div>
</div>


<div class="modal" id="reporte">
  <div class="modal-background"></div>
  <div class="modal-card" style="width: 96vw;height: 96vh;">
    <header class="modal-card-head">
      <p class="modal-card-title">
        <span class="icon">
          <i class="fa fa-file"></i>
        </span> Reporte
      </p>
      <button type="button" class="delete" (click)="ctrl.cancelarModal('reporte');"></button>
    </header>
    <section class="modal-card-body">

      <div style="width: 100%; height: 100%" id="contenido"></div>

    </section>
    <footer class="modal-card-foot">
      <a class="button is-success" (click)="ctrl.cancelarModal('reporte');">Cerrar</a>
    </footer>
  </div>
</div>
